import { useNavigation, Form, Link } from "@remix-run/react";
import { ArrowRight } from "lucide-react";
import { Button } from "~/components/ui/button";
import { Input } from "~/components/ui/input";

export default function CallToActionSection() {
  const navigation = useNavigation();
  return (
    <section className="dot-background container flex flex-col items-center gap-8 py-24 shadow-[inset_4px_4px_300px_50px_#ecfdf5]">
      <div className="flex max-w-[600px] flex-col items-center gap-3 text-pretty text-center">
        <h2 className="font-recursive text-4xl font-bold leading-normal">
          Try{" "}
          <span className="rounded-sm bg-emerald-500 px-2 py-1 text-white">
            free
          </span>{" "}
          for 14 days
        </h2>
        <p className="font-recursive text-lg">
          No credit card required — set up in minutes and experience the
          benefits.
        </p>
      </div>
      <div className="flex w-full max-w-[624px] flex-col items-center gap-4">
        <Form
          action="/login"
          method="POST"
          className="flex w-full flex-col gap-3 md:flex-row"
        >
          <Input
            name="email"
            type="email"
            required
            disabled={navigation.state === "submitting"}
            className="h-fit w-full bg-neutral-50 py-3 text-lg leading-normal"
            placeholder="name@yourcompany.com"
          />
          <Button
            className="h-fit w-full px-8 py-3 text-lg font-semibold leading-normal md:w-fit"
            disabled={navigation.state === "submitting"}
          >
            Try now <ArrowRight className="ml-1 h-6 w-6" />
          </Button>
        </Form>
        <div className="text-wrap text-center text-xs text-gray-500">
          By signing up, you agree to our{" "}
          <Link to="/terms" className="underline">
            Terms of Service
          </Link>{" "}
          and acknowledge our{" "}
          <Link to="/privacy" className="underline">
            Privacy Policy
          </Link>
        </div>
      </div>
    </section>
  );
}
